import { jsonp, ajax } from '@ifeng-fe/ui_base';
// apiUrl为webpack注入的全局变量
/* eslint-disable */
let apiBaseUrl = apiUrl;

/* eslint-enable */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

/**
 * 提交调查
 * @param {String} id 调查id
 * @param {String} sur 选项拼接字符串
 */
export const postSurvey = async (id, sur, isLoginAuth) => {
    try {
        const data = await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${sur}`, {
            data: { id, isLoginAuth },
            jsonpCallback: 'callback',
            cache: false,
        });

        return data;
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取热点调查
 * @param {String} type
 * @param {Number} num
 */
export const getSurveyHot = async (type = 'hot', num = 5) => {
    try {
        const res = await jsonp('//sv.ifeng.com/index.php/survey/getsort', {
            data: { type, num },
            jsonpCallback: 'callback',
            cache: false,
        });

        if (res.ifsuccess) {
            return res.data;
        }
    } catch (e) {
        console.error(e);
    }
};
